<template>
    <section class="ai-feedback-btns">
        <div class="btns">
            <span>{{ $t('cloud_ai.feedback.helpful') }}</span>
            <button class="feedbackBtn"
                :class="{ active: activeBtn === 'good' }"
                @click="handleFeedbackBtnClick('good')"
                :disabled="hasFeedback"
            >
                <svg xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    fill="none"
                    version="1.1"
                    width="14.36697769165039"
                    height="13.498292922973633"
                    viewBox="0 0 14.36697769165039 13.498292922973633"><g><path d="M9.82625,1.42558Q10.2399,2.66664,9.375,4.74833L12.0627,4.74829Q13.2358,4.74829,13.9218,5.7Q14.6077,6.6517,14.2368,7.76465L13.0378,11.3615Q12.7188,12.3185,11.8925,12.9097Q11.0699,13.4983,10.061,13.4983L7.70841,13.4983Q5.92221,13.4983,4.61812,12.3238Q4.53426,12.2483,4.44275,12.2483L3.54167,12.2483L3.54167,4.8083Q3.74417,4.74829,3.97082,4.74829L5.07641,4.74829Q7.35638,3.7082,6.6907,1.37833L6.66666,1.29419L6.66665,1.20669Q6.66658,0.513165,7.35143,0.181779Q7.82057,-0.0452279,8.44199,0.011253Q9.40077,0.149114,9.82625,1.42558ZM2.29167,5.165L1.45833,5.165Q0.854272,5.165,0.427136,5.59213Q0,6.01927,0,6.62333L0,10.79Q0,11.3941,0.427043,11.8212Q0.854179,12.2483,1.45833,12.2483L2.29167,12.2483L2.29167,5.165Z"
                        fill-rule="evenodd"
                        :fill="activeBtn === 'good' ? 'var(--b_6)' : 'var(--font_primary)'"
                        fill-opacity="1"/></g></svg>
                {{ $t('cloud_ai.feedback.good') }}

            </button>
            <button class="feedbackBtn"
                :class="{ active: activeBtn === 'bad' }"
                @click="handleFeedbackBtnClick('bad')"
                :disabled="hasFeedback"
            >
                <svg xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    fill="none"
                    version="1.1"
                    width="14.366980231324813"
                    height="13.498295626089204"
                    viewBox="0 0 14.366980231324813 13.498295626089204"><g transform="matrix(1,1.8814782265508256e-7,-1.8814782265508256e-7,-1,0.000002539674423017999,26.99658584594679)"><path d="M9.826252539674423,14.923872922973633Q10.239902539674423,16.164932922973634,9.375002539674423,18.246622922973632L12.062702539674422,18.246582922973634Q13.235802539674422,18.246582922973634,13.921802539674422,19.198292922973632Q14.607702539674422,20.14999292297363,14.236802539674423,21.262942922973632L13.037802539674423,24.859792922973632Q12.718802539674423,25.816792922973633,11.892502539674423,26.407992922973634Q11.069902539674423,26.996592922973633,10.061002539674423,26.996592922973633L7.708412539674423,26.996592922973633Q5.9222125396744225,26.996592922973633,4.618122539674424,25.82209292297363Q4.5342625396744225,25.746592922973633,4.442752539674423,25.746592922973633L3.541672539674423,25.746592922973633L3.541672539674423,18.306592922973632Q3.744172539674423,18.246582922973634,3.970822539674423,18.246582922973634L5.076412539674424,18.246582922973634Q7.3563825396744225,17.206492922973634,6.690702539674422,14.876622922973633L6.666662539674423,14.792482922973633L6.666652539674423,14.704982922973633Q6.6665825396744225,14.011457922973634,7.351432539674423,13.680071922973633Q7.820572539674423,13.453065022973632,8.441992539674423,13.509545922973633Q9.400772539674422,13.647406922973634,9.826252539674423,14.923872922973633ZM2.291672539674423,18.663292922973632L1.4583325396744231,18.663292922973632Q0.8542745396744232,18.663292922973632,0.4271385396744232,19.090422922973634Q0.000002539674423207572,19.51756292297363,0.000002539674423207572,20.121622922973632L0.000002539674423207572,24.288292922973632Q0.000002539674423207572,24.892392922973634,0.4270455396744232,25.31949292297363Q0.8541815396744232,25.746592922973633,1.4583325396744231,25.746592922973633L2.291672539674423,25.746592922973633L2.291672539674423,18.663292922973632Z"
                        fill-rule="evenodd"
                        :fill="activeBtn === 'bad' ? 'var(--b_6)' : 'var(--font_primary)'"
                        fill-opacity="1"/></g></svg>

                {{ $t('cloud_ai.feedback.bad') }}
            </button>
        </div>
        <reo-dialog
            v-if="showFeedbackDialog"
            @cancel="showFeedbackDialog = false"
        >
            <div>
                <ai-feedback
                    scene="search"
                    :user-input="userInput"
                    @submit="showFeedbackDialog = false;showFeedbackCompleteDialog = true;"
                />
            </div>
        </reo-dialog>
    </section>
</template>

<script lang="ts">
import Vue from 'vue';
import GoodIcon from '@/common/images/common/combo/co_praise.svg';
import BadIcon from '@/common/images/common/combo/co_bad.svg';
import { reportAiUsageFeedback } from '@/api/ai';
import AiFeedback from '@/components/AiFeedback.vue';
import ReoDialog from '@/basic/Dialog.vue';
import { requestWithErrorHandler } from '@/common/js/utils';

export default Vue.extend({
    components:{
        AiFeedback,
        ReoDialog
    },
    props:{
        userInput: Object
    },
    data() {

        return {
            GoodIcon,
            BadIcon,
            showFeedbackDialog: false,
            activeBtn: null as 'good' | 'bad' | null,
            showFeedbackCompleteDialog: false
        };

    },
    computed:{
        hasFeedback() {

            return this.activeBtn !== null;

        }
    },
    watch:{
        userInput:{
            handler() {

                this.activeBtn = null; // Reset active button when user input changes

            },
            deep: true,
        }
    },
    methods: {
        async handleFeedbackBtnClick( type: 'good' | 'bad' ) {

            await requestWithErrorHandler(() => reportAiUsageFeedback({
                scene: 'search',
                type,
                userInput: this.userInput
            }));
            if ( type === 'bad' ) {

                this.showFeedbackDialog = true;

            }
            this.activeBtn = type;

        }
    }
});
</script>

<style lang="less" scoped>
.ai-feedback-btns {
    position: relative;
    height: 57px;
    .btns{

        display: flex;
        align-items: center;
        gap: 12px;
        position: fixed;
        // 与筛选栏下方的内容起点对齐（80px 顶栏 + 120px 占位）。
        top: 200px;
        z-index: 4;
        background-color: @bg_01;
        // 填满与筛选栏之间的间隙，避免滚动时露出下方视频。
        box-shadow: 0 -8px var(--bg_01);
        width: 100%;
        max-width: 1200px;
        box-sizing: border-box;
        padding-bottom: 17px;
        .mobile({
            top: 176px;
            padding-left: 20px;
        });
        span{
            font-size: 14px;
            font-weight: 600;
        }
        .feedbackBtn{
            padding: 8px;
            border: none;
            outline: none;
            background-color: @bg_02;
            border-radius: @border-radius-level-button;
            cursor: pointer;
            display: flex;
            gap: 5px;
            align-items: center;
            font-size: 13px;
            line-height: 18px;
            &.active{
                color: @b_6;
            }
            &:disabled{
                cursor: not-allowed;
                color: @font_primary;
                &.active{
                    color: @b_6;
                }
            }
        }
    }
}

.app-platform .ai-feedback-btns .btns {
    top: 120px;
    .mobile({
        top: 126px;
    });
}

</style>
